import { Brewery } from '../../user-profile/codegen';
import { StaticBrewery, breweryData } from './exportedBreweryArray';

export const formatBreweryDisplay = (brewery: StaticBrewery | Brewery, useAlt = false) => {
  const code = useAlt ? brewery.altCode : brewery.code;
  return `${brewery.name?.trim()} (${code?.trim()})`;
};

export const loadStaticBreweriesList = () => {
  return breweryData.map((brewery) => formatBreweryDisplay(brewery)).sort((a, b) => (a < b ? -1 : 1));
};

export const findBrewery = ({
  breweryCode,
  breweries = breweryData,
  useAltCode = false
}: {
  breweryCode: string;
  breweries?: Brewery[];
  useAltCode?: boolean;
}): string => {
  const matchedBreweries = useAltCode
    ? breweries.filter((brewery) => brewery.altCode === breweryCode)
    : breweries.filter((brewery) => brewery.code === breweryCode); // Make this alt code

  if (matchedBreweries.length === 0 || matchedBreweries.length > 1) {
    return breweryCode;
  }

  return formatBreweryDisplay(matchedBreweries[0], useAltCode);
};

//API consts
export const getCodeFromFormattedString = (s: string) => s.substring(s.lastIndexOf('(') + 1, s.lastIndexOf(')')).trim();

//extract the variables to display
//format and sort
export const loadAndFormatApiBreweriesList = (jsonArray: Array<Brewery>): Array<string> => {
  const nonNullData = jsonArray.filter(
    (item) => item.code !== null && item.name !== null && item.code !== undefined && item.name !== undefined
  );

  const filteredJson: StaticBrewery[] = nonNullData.map((item) => ({
    code: item.code || '',
    name: item.name || ''
  }));

  return filteredJson.map((brewery) => formatBreweryDisplay(brewery)).sort((a, b) => (a < b ? -1 : 1));
};
